var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalysisFlatline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    "data-imageid": "analysis-flatline",
    imageName: "Analysis",
    className: "illustrations_image",
    style: {
      width: 183
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_001",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "262.79 261.99 260.91 268.93 231.63 258.33 242.04 255.79",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.91,269.43a.47.47,0,0,1-.17,0l-29.28-10.6a.5.5,0,0,1-.33-.5.49.49,0,0,1,.38-.46l10.41-2.53a.5.5,0,1,1,.24,1l-8.81,2.14,27.22,9.86,1.73-6.42a.51.51,0,0,1,.62-.36.52.52,0,0,1,.35.62l-1.88,6.94a.54.54,0,0,1-.25.32A.59.59,0,0,1,260.91,269.43Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.51,250.1a.5.5,0,0,1-.5-.5V40.12a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V249.6A.5.5,0,0,1,157.51,250.1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.47,269.62a.51.51,0,0,1-.36-.15L157.6,250.35l-18.51,19.12a.5.5,0,0,1-.71,0,.51.51,0,0,1,0-.71l18.87-19.48a.51.51,0,0,1,.72,0l18.87,19.48a.5.5,0,0,1,0,.71A.49.49,0,0,1,176.47,269.62Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.51,250.1a.5.5,0,0,1-.5-.5V40.12a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V249.6A.5.5,0,0,1,157.51,250.1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.47,269.62a.51.51,0,0,1-.36-.15L157.6,250.35l-18.51,19.12a.5.5,0,0,1-.71,0,.51.51,0,0,1,0-.71l18.87-19.48a.51.51,0,0,1,.72,0l18.87,19.48a.5.5,0,0,1,0,.71A.49.49,0,0,1,176.47,269.62Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.04,
    y: 44.6,
    width: 163.13,
    height: 120.57,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.16,165.69H76a.52.52,0,0,1-.52-.52V44.6a.51.51,0,0,1,.52-.51H239.16a.51.51,0,0,1,.52.51V165.17A.52.52,0,0,1,239.16,165.69Zm-162.61-1h162.1V45.12H76.55Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.06,
    cy: 96.43,
    r: 2.63,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142.65,
    cy: 86.48,
    r: 2.63,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.61,
    cy: 98.31,
    r: 2.63,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.76,
    cy: 109.57,
    r: 2.63,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.12,140.32S247.85,193.63,242,255.79l20.74,6.2,28-90.1,10.51,91,21.95.47s.2-54.35-5.43-123C306.4,140.12,265.12,140.32,265.12,140.32Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.6,112.81s22.51,28.12,32.89,27.22,23.25-22.12,23.25-22.12L256.13,99.18s-13.54,16.47-16,15.35-19.18-13.32-19.18-13.32",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,140.55c-10.71,0-31.88-26.29-32.79-27.43a.5.5,0,1,1,.78-.62c.23.27,22.47,27.89,32.46,27,9.41-.82,21.22-19.26,22.7-21.63l-10.1-17.85c-1.06,1.27-3.77,4.48-6.64,7.57-7.64,8.22-8.95,7.62-9.51,7.36-2.5-1.14-18.59-12.87-19.28-13.37a.51.51,0,0,1-.11-.7.5.5,0,0,1,.7-.1c.17.12,16.69,12.17,19.1,13.26,1,.45,7.22-5.21,15.43-15.21a.49.49,0,0,1,.43-.18.48.48,0,0,1,.39.25l10.61,18.73a.49.49,0,0,1,0,.51c-.53.88-13.11,21.44-23.63,22.36Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.13,108.12,329,102.41c-4.93-10.52-10.48-16.77-14.31-19.21-4.89-4.07-17-4.35-28.13-4.78a34.07,34.07,0,0,0-10.57,1c-13,3.59-25,22.36-25,22.36l11.61,6.92s-1.29,25.54.38,34.18c0,0,30.11,13,55.39,5.89C318.35,148.8,314.83,111.42,315.13,108.12Z",
    fill: "#fad347",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.49,75l-1.73,8.34s1.85,5.54,7.45,5a11.26,11.26,0,0,0,8.19-5.1l2-15.33s-3.74-2.69-1.38-11.27a27.16,27.16,0,0,1-14.38.07s-3.74,9.15-3.65,13.45S288.49,75,288.49,75Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.4,88.87c-5.28,0-7.11-5.3-7.13-5.35a.5.5,0,0,1,0-.27l1.64-7.88a5.25,5.25,0,0,1-3.42-5.23c-.09-4.36,3.53-13.28,3.68-13.66a.51.51,0,0,1,.61-.3,26.91,26.91,0,0,0,14.08-.06.52.52,0,0,1,.52.11.51.51,0,0,1,.14.51c-2.21,8.08,1.16,10.7,1.19,10.72a.53.53,0,0,1,.21.49l-2,15.33a.6.6,0,0,1-.06.19,11.69,11.69,0,0,1-8.58,5.35C294,88.85,293.68,88.87,293.4,88.87Zm-6.11-5.56c.31.81,2.14,5,6.87,4.48A10.8,10.8,0,0,0,301.9,83l1.94-15c-.81-.77-3.22-3.75-1.56-10.74a28.14,28.14,0,0,1-13.34-.06c-.72,1.83-3.52,9.2-3.44,12.82.08,3.8,3,4.37,3.08,4.39a.52.52,0,0,1,.42.62Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.24,67.19a3.55,3.55,0,0,1,1.46-1.74,6.52,6.52,0,0,1,2-.7,2.58,2.58,0,0,1,1.17,0,2.26,2.26,0,0,1,.74.38,2.78,2.78,0,0,1,1.13,1.55,3.32,3.32,0,0,1-.14,1.56,7,7,0,0,1-.64,1.6,4.35,4.35,0,0,1-6,1.48",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.27,72.42a4.91,4.91,0,0,1-2.55-.71.52.52,0,0,1-.17-.71.51.51,0,0,1,.71-.17,3.82,3.82,0,0,0,5.28-1.31,5.74,5.74,0,0,0,.59-1.47,2.83,2.83,0,0,0,.13-1.31,2.25,2.25,0,0,0-.93-1.24,1.52,1.52,0,0,0-.55-.3,2.18,2.18,0,0,0-.94,0,5.93,5.93,0,0,0-1.87.64,3.07,3.07,0,0,0-1.25,1.48.52.52,0,0,1-.67.3.53.53,0,0,1-.29-.67,4.12,4.12,0,0,1,1.67-2,7.07,7.07,0,0,1,2.2-.77,3,3,0,0,1,1.4,0,2.56,2.56,0,0,1,.92.47,3.26,3.26,0,0,1,1.32,1.85,3.76,3.76,0,0,1-.15,1.81,6.62,6.62,0,0,1-.69,1.72,4.89,4.89,0,0,1-3,2.23A4.53,4.53,0,0,1,303.27,72.42Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.16,76.18a.52.52,0,0,1-.12-1,11.9,11.9,0,0,0,7.46-5.74,20.27,20.27,0,0,0,2.19-14.19c-.67-2.67-1.54-3.43-2.16-3.6a2,2,0,0,0-1.66.56.52.52,0,0,1-.59.11.53.53,0,0,1-.29-.52c0-.14.29-3.36-3-6.6-2.45-2.37-10.47-5.32-16.54-4.53-3.12.41-5.36,1.72-6.66,3.89-1.39,2.34-1.8,4.5-1.22,6.43a8.33,8.33,0,0,0,4,4.52.51.51,0,0,1-.44.93,9.22,9.22,0,0,1-4.57-5.14c-.68-2.22-.24-4.67,1.32-7.27,1.46-2.45,3.95-3.93,7.4-4.38,6.59-.87,14.84,2.32,17.4,4.81A10.5,10.5,0,0,1,311,50.86a2.49,2.49,0,0,1,1.8-.23c1.28.35,2.25,1.81,2.89,4.35a21.36,21.36,0,0,1-2.31,15,13,13,0,0,1-8.09,6.22Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.82,79.18a7.15,7.15,0,0,0,5.81-1.06c2.7-2,2.67-3.35,2.67-3.35s-4.14,1.59-7.6.4Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.59,79.9a7.23,7.23,0,0,1-1.91-.24.49.49,0,0,1-.34-.58l.87-4a.51.51,0,0,1,.24-.33.53.53,0,0,1,.41,0c3.24,1.12,7.22-.38,7.26-.4a.5.5,0,0,1,.68.46c0,.16-.05,1.68-2.88,3.76A7.23,7.23,0,0,1,289.59,79.9Zm-1.17-1.1a6.57,6.57,0,0,0,4.91-1.08,8.11,8.11,0,0,0,2.16-2.17,12.76,12.76,0,0,1-6.42.26Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,143.41a.51.51,0,0,1-.5-.47,235.07,235.07,0,0,1,4.27-52,.49.49,0,0,1,.58-.39.5.5,0,0,1,.4.59,234.14,234.14,0,0,0-4.25,51.72.5.5,0,0,1-.47.53Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.14,138.73c0-.78-4.12-32-4.12-32l-30.18-1.55,5.16,31Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.92,99.53s23.37,41.39,8.45,43.92c-10.39,1.77-31.12-3-38.86-7s-10.95-6.92-10.95-6.92-8.64-.64-7.61-2.7a2.92,2.92,0,0,1,3.23-1.55s-4.13-.39-3.61-2.32,3.87-1.29,3.87-1.29-5.81-2.07-4.26-3.23,4.51-.26,4.51-.26-4-.72-3.86-2.45c.24-2.93,12.76.26,15.21,2.58s17.37,4.65,20.08,4.91l-7-14.92",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.15,144.33c-11.13,0-27.14-4-33.87-7.47A58.56,58.56,0,0,1,286.36,130c-1.48-.12-6.92-.66-7.83-2.28a1.16,1.16,0,0,1,0-1.14,3.24,3.24,0,0,1,1.24-1.38,3.12,3.12,0,0,1-1.43-1,1.58,1.58,0,0,1-.24-1.37,2.34,2.34,0,0,1,1.9-1.64c-1.24-.6-2.43-1.37-2.55-2.16a1,1,0,0,1,.45-1,3.58,3.58,0,0,1,1.45-.6,2,2,0,0,1-1-1.75,1.55,1.55,0,0,1,1.15-1.34c3-1.16,12.62,1.43,14.91,3.6,2.09,2,14.56,4.13,18.9,4.67l-6.66-14.11a.5.5,0,0,1,.24-.67.51.51,0,0,1,.67.24l7,14.93a.5.5,0,0,1,0,.5.52.52,0,0,1-.45.21c-2.49-.24-17.74-2.55-20.38-5-2-1.92-11.21-4.41-13.87-3.4-.48.19-.5.41-.51.5-.05.7,1.33,1.36,2.62,1.72a6.29,6.29,0,0,1,.9.21.49.49,0,0,1,.34.59.5.5,0,0,1-.57.38c-.12,0-.46-.09-.9-.21a4.58,4.58,0,0,0-3.23.37c0,.49,2,1.6,4.12,2.36a.49.49,0,0,1,.32.6.5.5,0,0,1-.58.36s-2.91-.51-3.29.92a.6.6,0,0,0,.09.55,4.5,4.5,0,0,0,2.61,1.09,3.57,3.57,0,0,1,.54.07.5.5,0,0,1-.16,1l-.44-.06A2.34,2.34,0,0,0,279.4,127a.18.18,0,0,0,0,.2c.51.9,4.52,1.58,7.2,1.79a.47.47,0,0,1,.3.12s3.27,2.94,10.84,6.85,28.33,8.72,38.54,7a4.79,4.79,0,0,0,3.78-2.76c4.63-9.74-12.4-40.12-12.58-40.43a.5.5,0,0,1,.87-.49c.72,1.27,17.47,31.15,12.61,41.35a5.77,5.77,0,0,1-4.51,3.31A31.74,31.74,0,0,1,331.15,144.33Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.55,103.28s-6-16-7.31-15.44,1,10.49,1,10.49-9.59-10.44-10.83-9.76-.46,3.26,3.15,8.56c0,0-6.37-7.35-7.38-5.82s5.24,8.12,5.24,8.12-6-6.35-6.85-5.08,5.67,7.87,5.67,7.87-6.1-7.1-6.52-4.9,11.67,16.52,15.14,20.46",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.87,118.28a.46.46,0,0,1-.37-.17c-.16-.18-15.82-18-15.26-20.89a.92.92,0,0,1,.68-.79,1.42,1.42,0,0,1,.89.13c-.67-1.07-1-2-.65-2.48a.86.86,0,0,1,.67-.39,3.57,3.57,0,0,1,1.94.84c-.93-1.45-1.48-2.78-1-3.5a1,1,0,0,1,.76-.43c.94-.06,2.55,1.22,4.07,2.67-1.29-2.46-1.32-3.52-1.17-4.14a1.48,1.48,0,0,1,.75-1c1-.54,4.4,2.32,10.17,8.49-.93-4.29-1.57-8.77-.29-9.25a.72.72,0,0,1,.57,0c1.7.77,6.09,12.22,7.39,15.71a.5.5,0,0,1-.93.35c-2.53-6.76-5.65-14-6.74-15-.32.94.41,5.69,1.39,9.8a.49.49,0,0,1-.25.55.5.5,0,0,1-.61-.1C212.63,94,207.67,89.23,206.6,89a.53.53,0,0,0-.2.33c-.18.74.29,2.65,3.58,7.48a.5.5,0,0,1-.79.61c-2.86-3.3-5.94-6-6.61-5.86-.4.62,2,4.1,5.19,7.46l0,0h0a.5.5,0,0,1-.73.69s0,0,0,0c-2.59-2.74-5.28-5-6-5,0,.56,1.19,2.28,3,4.33,1,1,2,2.15,2.67,2.88a.51.51,0,0,1,0,.69.5.5,0,0,1-.7,0c-.81-.83-1.79-1.86-2.71-2.92-1.44-1.4-2.64-2.33-3-2.27-.24,1.54,8.61,12.72,15.08,20.06a.51.51,0,0,1-.05.71A.5.5,0,0,1,214.87,118.28Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.25,98.33a4.67,4.67,0,0,0-1.8,5.7",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.45,104.53a.52.52,0,0,1-.48-.33,5.21,5.21,0,0,1,2-6.3.49.49,0,0,1,.68.18.5.5,0,0,1-.17.68,4.15,4.15,0,0,0-1.59,5.1.51.51,0,0,1-.31.64A.45.45,0,0,1,215.45,104.53Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.26,262.93l.63,6.73h31.29a63.34,63.34,0,0,0-10-6.26",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.18,270.16H301.89a.51.51,0,0,1-.5-.46l-.62-6.73a.49.49,0,0,1,.45-.54.49.49,0,0,1,.54.45l.59,6.28h29.34a70.67,70.67,0,0,0-8.71-5.32.5.5,0,0,1,.46-.89,64.26,64.26,0,0,1,10.05,6.32.48.48,0,0,1,.16.55A.51.51,0,0,1,333.18,270.16Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.34,270.1H57.55a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5H359.34a.5.5,0,0,1,.5.5A.5.5,0,0,1,359.34,270.1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.76,175.77a.45.45,0,0,1-.16,0l-15.77-5.64a.49.49,0,0,1,.33-.93l15.77,5.63a.5.5,0,0,1-.17,1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.66,160.37a.5.5,0,0,1-.05-1c7.05-.7,8.55-9.26,8.57-9.35a.5.5,0,0,1,.57-.41.51.51,0,0,1,.41.58c0,.09-1.65,9.39-9.45,10.17Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.22,160.37a.34.34,0,0,1-.14,0,8.48,8.48,0,0,1-6.36-8.39.48.48,0,0,1,.52-.46.49.49,0,0,1,.47.52,7.4,7.4,0,0,0,5.65,7.38.49.49,0,0,1-.14,1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.5,62.53s-3.55,3.74-3,4.59,2.52.69,2.52.69",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.61,68.32a3.12,3.12,0,0,1-2.54-.93c-.63-1,1.32-3.37,3.06-5.2a.5.5,0,0,1,.71,0,.49.49,0,0,1,0,.7c-1.61,1.7-3,3.58-2.92,4,.23.35,1.35.47,2,.41a.5.5,0,0,1,.54.45.49.49,0,0,1-.45.54Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.89,70.74s3,1.56,4.35-1.35",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.65,71.65a4.77,4.77,0,0,1-2-.47.49.49,0,0,1-.21-.67.5.5,0,0,1,.67-.22,3.33,3.33,0,0,0,2.28.25,2.46,2.46,0,0,0,1.39-1.36.5.5,0,0,1,.9.42,3.19,3.19,0,0,1-3,2.05Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 298.31,
    cy: 63.23,
    rx: 1,
    ry: 0.71,
    transform: "translate(128.28 316.37) rotate(-68.08)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 290.94,
    cy: 62.03,
    rx: 1,
    ry: 0.71,
    transform: "translate(124.78 308.77) rotate(-68.08)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.91,250.44h-13a.5.5,0,0,1-.43-.24c-3.86-6.48-8.39-16.49-8.08-27.4a.49.49,0,0,1,.23-.41.5.5,0,0,1,.46,0,38.74,38.74,0,0,1,10.09,6.58.5.5,0,0,1-.66.74,40.22,40.22,0,0,0-9.13-6.09c-.08,10.25,4.14,19.65,7.8,25.86h12.7a.5.5,0,1,1,0,1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.32,250.44h-14a.51.51,0,0,1-.47-.34,90,90,0,0,1-4.52-20.76,60.49,60.49,0,0,1,2.4-24.44.5.5,0,0,1,.33-.32.52.52,0,0,1,.45.09c.14.11,13.22,10.77,16.41,27.4a.5.5,0,0,1-1,.18c-2.74-14.29-13-24.1-15.49-26.32a60,60,0,0,0-2.12,23.32,89.17,89.17,0,0,0,4.35,20.19h13.6a.5.5,0,0,1,0,1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.36,250.44H107a.5.5,0,0,1-.5-.48c-.11-3.47.62-9.18,4.75-16.65.27-.48.53-.95.79-1.4,7.23-12.23,13.89-12.24,14.15-12.24a.5.5,0,0,1,.48.4c2.81,13-3.11,24.45-6.89,30.15A.5.5,0,0,1,119.36,250.44Zm-11.87-1H119.1c3.65-5.58,9.16-16.48,6.69-28.73-1.48.22-7,1.7-12.88,11.71-.26.44-.52.9-.79,1.38C108.29,240.73,107.47,246.06,107.49,249.44Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.11 269.54 92.87 269.54 88.97 249.95 121.02 249.95 117.11 269.54",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.59,90.24a30.66,30.66,0,0,0,61.31,0H122.25V59.58A30.67,30.67,0,0,0,91.59,90.24Z",
    fill: "#fad347",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.2,55.06V85.72h30.66A30.67,30.67,0,0,0,127.2,55.06Z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.99,
    y: 157.08,
    width: 21,
    height: 18.46,
    fill: "#fad347",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.01,
    y: 155.17,
    width: 2.44,
    height: 3.71,
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.24,163H99.88a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h6.36a.5.5,0,0,1,.5.5A.5.5,0,0,1,106.24,163Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.12,167H99.88a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h11.24a.5.5,0,0,1,.5.5A.5.5,0,0,1,111.12,167Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.75,163.15h-4.69a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h4.69a.5.5,0,0,1,.5.5A.5.5,0,0,1,113.75,163.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.94,
    y: 50.63,
    width: 18.54,
    height: 16.29,
    fill: "#fad347",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.89,
    y: 48.95,
    width: 2.15,
    height: 3.28,
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.35,55.78h-12a.34.34,0,1,1,0-.68h12a.34.34,0,1,1,0,.68Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.35,59.28h-12a.35.35,0,0,1,0-.69h12a.35.35,0,1,1,0,.69Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,62.77H73.37a.34.34,0,1,1,0-.68H81a.34.34,0,1,1,0,.68Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.93,133.78H93a.47.47,0,0,1,0-.93h33.93a.47.47,0,0,1,0,.93Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.72,133.78h-6.46a.47.47,0,0,1,0-.93h6.46a.47.47,0,0,1,0,.93Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.66,133.21h-6.45a.46.46,0,0,1-.46-.46.47.47,0,0,1,.46-.46h6.45a.46.46,0,0,1,.46.46A.45.45,0,0,1,151.66,133.21Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.74,141.66h-50a.47.47,0,0,1-.46-.46.46.46,0,0,1,.46-.46h50a.45.45,0,0,1,.46.46A.46.46,0,0,1,142.74,141.66Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.13,149.54H92.88a.46.46,0,0,1-.46-.46.47.47,0,0,1,.46-.46h16.25a.47.47,0,0,1,.46.46A.46.46,0,0,1,109.13,149.54Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.08,149.26H119.17a.45.45,0,0,1-.46-.46.46.46,0,0,1,.46-.46h28.91a.47.47,0,0,1,.46.46A.46.46,0,0,1,148.08,149.26Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.93,133.81H93a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h33.93a.5.5,0,0,1,.5.5A.5.5,0,0,1,126.93,133.81Z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.72,133.81h-6.46a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h6.46a.51.51,0,0,1,.5.5A.5.5,0,0,1,139.72,133.81Z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.66,133.25h-6.45a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h6.45a.5.5,0,0,1,.5.5A.5.5,0,0,1,151.66,133.25Z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.74,141.7h-50a.5.5,0,0,1,0-1h50a.5.5,0,0,1,0,1Z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.13,149.58H92.88a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h16.25a.5.5,0,0,1,.5.5A.5.5,0,0,1,109.13,149.58Z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.08,149.3H119.17a.5.5,0,0,1,0-1h28.91a.5.5,0,0,1,0,1Z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.83,
    y: 124.49,
    width: 10.34,
    height: 29.32,
    fill: "#fad347",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.67,
    y: 134.45,
    width: 10.34,
    height: 19.37,
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.5,
    y: 128.78,
    width: 10.34,
    height: 25.03,
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.33,61.55h-54a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h54a.5.5,0,0,1,.5.5A.51.51,0,0,1,221.33,61.55Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.68,69.43H168.14a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h41.54a.5.5,0,0,1,.5.5A.5.5,0,0,1,209.68,69.43Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.51,77H167.35a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h48.16a.51.51,0,0,1,.5.5A.5.5,0,0,1,215.51,77Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.18,69.06h-7.67a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h7.67a.5.5,0,0,1,.5.5A.5.5,0,0,1,223.18,69.06Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.43,115.51H168.27a.5.5,0,0,1-.5-.5V91.93a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v22.58h27.66a.5.5,0,0,1,.5.5A.5.5,0,0,1,196.43,115.51Z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.27,115.51a.49.49,0,0,1-.36-.84L179.73,102a.5.5,0,0,1,.42-.15.48.48,0,0,1,.37.23L183,106l8-8.8a.5.5,0,0,1,.71,0,.49.49,0,0,1,0,.7l-8.44,9.29a.52.52,0,0,1-.42.17.49.49,0,0,1-.38-.24l-2.47-4-11.38,12.19A.49.49,0,0,1,168.27,115.51Z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.87,154.09H163.49a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h61.38a.5.5,0,0,1,.5.5A.51.51,0,0,1,224.87,154.09Z",
    fill: "#e6e7e8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysisFlatline);
export default __webpack_public_path__ + "static/media/analysis-flatline.bfc8da60a7a6136a5516b0eeb008ca6c.svg";
export { ForwardRef as ReactComponent };